import React from 'react';
import PropTypes from 'prop-types';
import { Form } from '@ant-design/compatible';
import { Input, Row, Col, DatePicker, Checkbox, Radio, Tooltip, Icon, Switch } from 'antd';
import moment from 'moment';
import { bookingJourneyType } from 'common/constants/booking';
import { currencySymbols } from '~helpers/currency';
import { QuestionCircleOutlined } from '@ant-design/icons';
import BaseSetup from '@pages/dashboard/payment/long-tail/setup/base';
import '@ant-design/compatible/assets/index.css';
import classNames from 'classnames';
import AppliedProperties from 'common/components/applied-properties';
import { paymentPlanCategoryType } from 'common/constants/landlord';

class InitialSetupForm extends BaseSetup {
  constructor(props) {
    super(props);

    this.state = {
      startValue: null,
      endValue: null,
      propertiesSlugsExcluded: [],
      enableSelectProperty: false,

      hasSemiautomatic: false,

      choosePaymentApcategory: paymentPlanCategoryType.RENT_IS_REQUIRED,
    };

    this.openEndDate = '9999-12-31';
  }

  componentDidMount() {
    if (this.props.paymentPlan) {
      this.props.form.setFieldsValue({
        name: this.props.paymentPlan.name,
        currency: this.props.paymentPlan.currency,
        description: this.props.paymentPlan.description,
        startDate: moment(this.props.paymentPlan.startDate),
        endDate:
          this.props.paymentPlan.endDate === this.openEndDate
            ? null
            : moment(this.props.paymentPlan.endDate),
        openEnd: this.props.paymentPlan.endDate === this.openEndDate,
        properties: this.props.paymentPlan.properties,
      });
    }
  }

  handlePropertiesChange = (properties = [], isTouched = false) => {
    let hasSemiautomatic = properties?.some(
      property => property?.bookingJourney === bookingJourneyType.SEMI_AUTOMATIC,
    );
    this.setState({ hasSemiautomatic });
    this.props.form.setFields({ properties: { value: properties, touched: isTouched } });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.paymentPlan !== this.props.paymentPlan && this.props.paymentPlan) {
      this.props.form.setFieldsValue({
        name: this.props.paymentPlan.name,
        currency: this.props.paymentPlan.currency,
        description: this.props.paymentPlan.description,
        startDate: moment(this.props.paymentPlan.startDate),
        endDate:
          this.props.paymentPlan.endDate === this.openEndDate
            ? null
            : moment(this.props.paymentPlan.endDate),
        openEnd: this.props.paymentPlan.endDate === this.openEndDate,
        properties: this.props.paymentPlan.properties,
      });
      let isSemiautomatic = this.props?.paymentPlan?.properties?.some(
        property => property?.bookingJourney === bookingJourneyType.SEMI_AUTOMATIC,
      );

      this.setState({ hasSemiautomatic: !!isSemiautomatic });
    }
  }

  onChange = (field, value) => {
    this.setState({
      [field]: value,
    });
  };

  onStartChange = value => {
    this.setState({
      startValue: value,
    });
  };

  onEndChange = value => {
    this.setState({
      endValue: value,
    });
  };

  disabledStartDate = startValue => {
    const { endValue } = this.state;

    return (
      (startValue && startValue.valueOf() <= moment().subtract(1, 'day').valueOf()) ||
      (endValue && startValue && startValue.isAfter(moment(endValue)))
    );
  };

  disabledEndDate = endValue => {
    const { startValue } = this.state;

    return (
      (endValue && endValue.valueOf() < moment().valueOf()) ||
      (endValue && startValue && startValue.isAfter(moment(endValue).subtract(1, 'day')))
    );
  };
  changeMustPay = e => {
    this.setState({ choosePaymentApcategory: e.target.value });
    this.props?.updatePaymentplanCategory?.(e.target.value);
    const { resetFields } = this.props.form;
    resetFields('properties');
    resetFields('currency');
  };
  render() {
    const { getFieldDecorator, getFieldValue, resetFields } = this.props.form;
    const { t, isEditPage, paymentplanCategory, hasKeyProperty, landlord, paymentOnline } =
      this.props;
    const { allowNoPayment } = landlord;

    // eslint-disable-next-line no-unused-vars
    const { ALL, ...symbols } = currencySymbols;

    const choseCategory = isEditPage
      ? paymentplanCategory
      : paymentPlanCategoryType.RENT_IS_REQUIRED;
    const currencyOpts = Object.keys(symbols)?.sort();
    //当没有nopayment的权限且设置的是paymentPlan是不需要付款的

    //没有权限设置no payment时的create 页面
    const cannotCreateNoPayment = !isEditPage && !allowNoPayment && allowNoPayment !== undefined;
    // edit页面和有权限时设置no payment
    const canCreateOrEditNoPayment = isEditPage || (!isEditPage && allowNoPayment);
    return (
      <div className="long-tail__initial-setup">
        <Form className="long-tail__initial-setup__form">
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                label={t('landlord.payment.long_tail.initial_setup.label.plan_name')}
                colon={false}
              >
                {getFieldDecorator('name', {
                  rules: [
                    {
                      required: true,
                      validator: (rule, value, callback) => {
                        if (value && value !== '' && value.length <= 30) {
                          callback();
                        } else if (value && value !== '' && value.length > 30) {
                          callback(
                            t(
                              'landlord.payment.long_tail.initial_setup.err.plan_name.30_characters',
                            ),
                          );
                        } else {
                          callback(t('landlord.payment.long_tail.initial_setup.err.plan_name'));
                        }
                      },
                    },
                  ],
                })(
                  <Input
                    size="large"
                    placeholder={t(
                      'landlord.payment.long_tail.initial_setup.placeholder.plan_name',
                    )}
                  />,
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={t('landlord.payment.long_tail.initial_setup.label.description')}
                colon={false}
              >
                {getFieldDecorator('description', {
                  rules: [
                    {
                      validator: (rule, value, callback) => {
                        if (!value || value.length <= 255) {
                          callback();
                        } else {
                          callback(t('landlord.payment.long_tail.decription.error'));
                        }
                      },
                    },
                  ],
                })(
                  <Input
                    size="large"
                    placeholder={t(
                      'landlord.payment.long_tail.initial_setup.placeholder.description',
                    )}
                  />,
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                label={t('landlord.payment.long_tail.initial_setup.label.effictive_from_date')}
                colon={false}
              >
                {getFieldDecorator('startDate', {
                  rules: [
                    {
                      required: true,
                      message: t('landlord.payment.long_tail.initial_setup.err.from_date'),
                    },
                  ],
                  initialValue: this.state.startValue,
                })(
                  <DatePicker
                    disabledDate={this.disabledStartDate}
                    size="large"
                    onChange={this.onStartChange}
                    style={{
                      width: '100%',
                    }}
                  />,
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <label
                className="long-tail__initial-setup__label long-tail__initial-setup__label--required"
                style={{ marginTop: '10px' }}
              >
                {t('landlord.payment.long_tail.initial_setup.label.effictive_end_date')}
                <div className="long-tail__initial-setup__open-end">
                  <div className="long-tail__initial-setup__open-end-checkbox">
                    <Form.Item>
                      {getFieldDecorator('openEnd', { valuePropName: 'checked' })(
                        <Checkbox onChange={() => resetFields(['endDate'])} />,
                      )}
                    </Form.Item>
                  </div>
                  <span className="long-tail__initial-setup__open-end-text">
                    {t('landlord.payment.long_tail.open_end.field')}
                  </span>
                </div>
              </label>
              <Form.Item>
                {getFieldDecorator('endDate', {
                  rules: [
                    {
                      required: !getFieldValue('openEnd'),
                      message: t('landlord.payment.long_tail.initial_setup.err.end_date'),
                    },
                  ],
                  initialValue: getFieldValue('openEnd') ? null : this.state.endValue,
                })(
                  <DatePicker
                    size="large"
                    disabled={getFieldValue('openEnd')}
                    disabledDate={this.disabledEndDate}
                    onChange={this.onEndChange}
                    style={{ width: '100%' }}
                    placeholder={
                      getFieldValue('openEnd')
                        ? ''
                        : t('landlord.payment.long_tail.open_end.placeholder')
                    }
                  />,
                )}
              </Form.Item>
            </Col>
          </Row>

          <If condition={cannotCreateNoPayment}>
            <div className="long-tail__initial-setup__mustPayBox">
              <label
                className="long-tail__initial-setup__label long-tail__initial-setup__label--required"
                style={{ marginTop: '10px' }}
              >
                {t('landlord.payment.long_tail.initial_setup.label.student_must_pay')}
                <Tooltip
                  overlayStyle={{ zIndex: '10000000', fontSize: '14px', maxWidth: '240px' }}
                  title={t(
                    'landlord.payment.long_tail.initial_setup.label.student_must_pay.tooltip',
                  )}
                >
                  <QuestionCircleOutlined className="long-tail__initial-setup__label-must_pay_icon" />
                </Tooltip>
              </label>
              <Form.Item
                className={!hasKeyProperty && 'long-tail__initial-setup__mustPay-radioGroup'}
              >
                {getFieldDecorator('category', {
                  trigger: 'onChange',
                  initialValue: choseCategory,
                })(
                  <Radio.Group
                    onChange={this.changeMustPay}
                    disabled={isEditPage || !hasKeyProperty}
                  >
                    <Radio value={paymentPlanCategoryType.DEPOSIT_IS_REQUIRED}>
                      {t('landlord.payment.long_tail.deposit_or_fees.title')}
                    </Radio>
                    <Radio value={paymentPlanCategoryType.RENT_IS_REQUIRED}>
                      {t('rent_payment')}
                    </Radio>
                  </Radio.Group>,
                )}
              </Form.Item>
              {!hasKeyProperty && (
                <div className="long-tail__initial-setup__mustPay-hint">
                  <span>
                    <Icon type="info-circle" className="long-tail__initial-setup__mustPay-Icon" />
                  </span>

                  <span>{t('cms:cms.payment.landlord.no_key_property.hint')}</span>
                </div>
              )}
            </div>
            <div
              className={classNames('long-tail__initial-setup__must-pay-part', {
                'long-tail__initial-setup__must-pay-noPayment': !paymentOnline,
              })}
            >
              <div
                className={classNames('long-tail__initial-setup__triangle', {
                  'long-tail__initial-setup__triangle-rent': isEditPage
                    ? choseCategory === paymentPlanCategoryType.RENT_IS_REQUIRED
                    : this.state.choosePaymentApcategory ===
                      paymentPlanCategoryType.RENT_IS_REQUIRED,
                })}
              />
              <AppliedProperties
                currencyOptions={currencyOpts}
                paymentPlanId={this.props.paymentPlan?.id}
                form={this.props.form}
                selectedProperties={
                  this.props.paymentPlan ? this.props.paymentPlan?.properties : []
                }
                landlordId={landlord?.id}
                selectedCurrency={getFieldValue('currency')}
                onChange={this.handlePropertiesChange}
                isDepositRequired={
                  isEditPage
                    ? choseCategory === paymentPlanCategoryType.DEPOSIT_IS_REQUIRED
                    : this.state.choosePaymentApcategory ===
                      paymentPlanCategoryType.DEPOSIT_IS_REQUIRED
                }
              />
            </div>
          </If>
          <If condition={canCreateOrEditNoPayment}>
            <div className="long-tail__initial-setup__online-payment">
              <div className="long-tail__initial-setup__online-payment--header">
                <div className="long-tail__initial-setup__online-payment--hint">
                  {t('landlord.payment.long_tail.student_must_payment.hint')}
                  <Tooltip
                    overlayStyle={{ zIndex: '10000000', fontSize: '14px', maxWidth: '240px' }}
                    title={t(
                      'landlord.payment.long_tail.initial_setup.label.student_must_pay.tooltip',
                    )}
                  >
                    <QuestionCircleOutlined className="long-tail__initial-setup__label-must_pay_icon" />
                  </Tooltip>
                </div>
                <div>
                  <Form.Item className="long-tail__initial-setup__online-payment--formItem">
                    {getFieldDecorator('paymentOnline', {
                      trigger: 'onChange',
                      initialValue: paymentOnline ? true : false,
                      valuePropName: 'checked',
                    })(
                      <Switch
                        checkedChildren={<Icon type="check" />}
                        unCheckedChildren={<Icon type="close" />}
                        disabled={isEditPage}
                        onChange={checked => {
                          this.props.setPaymentOnline(checked);
                        }}
                      />,
                    )}
                    <span className="long-tail__initial-setup__online-payment--state">
                      {paymentOnline ? 'Yes' : 'No'}
                    </span>
                  </Form.Item>
                </div>
              </div>
              {!paymentOnline && (
                <div
                  className="long-tail__initial-setup__online-payment--notPaymentOnline"
                  style={{ display: 'flex' }}
                >
                  <Icon
                    type="exclamation-circle"
                    theme="filled"
                    style={{ marginRight: '6px', marginTop: '5px' }}
                  />
                  <span>{t('landlord.payment.long_tail.not_payment_online.hint')}</span>
                </div>
              )}
              <div
                className={classNames({
                  'long-tail__initial-setup__online-payment--contents': paymentOnline,
                  'long-tail__initial-setup__online-noPayment--contents': !paymentOnline,
                })}
              >
                <If condition={paymentOnline}>
                  <div className="long-tail__initial-setup__onlinePaymentBox">
                    <Form.Item
                      className={!hasKeyProperty && 'long-tail__initial-setup__mustPay-radioGroup'}
                    >
                      {getFieldDecorator('category', {
                        trigger: 'onChange',
                        initialValue: choseCategory,
                      })(
                        <Radio.Group
                          onChange={this.changeMustPay}
                          disabled={isEditPage || !hasKeyProperty}
                        >
                          <Radio value={paymentPlanCategoryType.DEPOSIT_IS_REQUIRED}>
                            {t('landlord.payment.long_tail.deposit_or_fees.title')}
                          </Radio>
                          <Radio value={paymentPlanCategoryType.RENT_IS_REQUIRED}>
                            {t('rent_payment')}
                          </Radio>
                        </Radio.Group>,
                      )}
                    </Form.Item>
                    {!hasKeyProperty && (
                      <div className="long-tail__initial-setup__mustPay-hint">
                        <span>
                          <Icon
                            type="info-circle"
                            className="long-tail__initial-setup__mustPay-Icon"
                          />
                        </span>

                        <span>{t('cms:cms.payment.landlord.no_key_property.hint')}</span>
                      </div>
                    )}
                  </div>
                </If>

                <div
                  className={classNames({
                    'long-tail__initial-setup__must-pay-part': paymentOnline,
                  })}
                >
                  <div
                    className={classNames('long-tail__initial-setup__triangle', {
                      'long-tail__initial-setup__triangle-rent': isEditPage
                        ? choseCategory === paymentPlanCategoryType.RENT_IS_REQUIRED
                        : this.state.choosePaymentApcategory ===
                          paymentPlanCategoryType.RENT_IS_REQUIRED,
                    })}
                  />
                  <AppliedProperties
                    currencyOptions={currencyOpts}
                    paymentPlanId={this.props.paymentPlan?.id}
                    form={this.props.form}
                    selectedProperties={
                      this.props.paymentPlan ? this.props.paymentPlan?.properties : []
                    }
                    landlordId={landlord?.id}
                    selectedCurrency={getFieldValue('currency')}
                    onChange={this.handlePropertiesChange}
                    isDepositRequired={
                      isEditPage
                        ? choseCategory === paymentPlanCategoryType.DEPOSIT_IS_REQUIRED
                        : this.state.choosePaymentApcategory ===
                          paymentPlanCategoryType.DEPOSIT_IS_REQUIRED
                    }
                  />
                </div>
              </div>
            </div>
          </If>
        </Form>
      </div>
    );
  }
}

const LongtailInitialSetup = Form.create({
  name: 'long-tail-initial-setup',
})(InitialSetupForm);
export default LongtailInitialSetup;

LongtailInitialSetup.propTypes = {
  t: PropTypes.func.isRequired,
  isEditPage: PropTypes.bool,
  paymentplanCategory: PropTypes.string,
  updatePaymentplanCategory: PropTypes.func,
  properties: PropTypes.array,
};

LongtailInitialSetup.defaultProps = {
  t: () => {},
  isEditPage: false,
  paymentplanCategory: '',
  updatePaymentplanCategory: () => {},
  properties: [],
};
